module.exports = __webpack_public_path__ + "media/invest/footer-34525222.jpg";